import { render, staticRenderFns } from "./PreferenceSwiper.vue?vue&type=template&id=5441a6aa&scoped=true"
import script from "./PreferenceSwiper.vue?vue&type=script&lang=js"
export * from "./PreferenceSwiper.vue?vue&type=script&lang=js"
import style0 from "./PreferenceSwiper.vue?vue&type=style&index=0&id=5441a6aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5441a6aa",
  null
  
)

export default component.exports